<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش ها و داشبورد </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 px-2 w-100 mt-2 py-1">

    <div class="row gx-2 gy-2 w-100 mt-2 ">

        <div id="chart1" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> ورود به برنامه  </p>

                <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart2" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> منبع بازدید سایت </p>

                <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart3" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد سفر به تفکیک تاریخ   </p>

                <canvas id="myChart3" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart4" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> سفرها به تفکیک شهرهای مبدا </p>

                <canvas id="myChart4" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart5" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> سفرها به تفکیک شهرهای مقصد </p>

                <canvas id="myChart5" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart6" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> سفرها به تفکیک مبدا - مقصد </p>

                <canvas id="myChart6" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart7" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> ساعت شروع سفر </p>

                <canvas id="myChart7" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart8" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> ساعت ثبت سفر </p>

                <canvas id="myChart8" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart9" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> سفرها به تفکیک راننده </p>

                <canvas id="myChart9" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart10" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> سفرهای همکاران </p>

                <canvas id="myChart10" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart11" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="">

                <p class="text-center f18 dirI"> سفرها به تفکیک گروه خودرویی </p>

                <canvas id="myChart11" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart12" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <p class="text-center f18 bg-success p-2 rounded text-white "> پراکندگی مبدا سفر ها </p>

            <div id="map1" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>


    </div>

</div>